import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { Wrapper } from './styles';

import Tooltip from '@spa/shared/components/Tooltip';
import { SERVICES_FEATURES } from '@spa/shared/constants/services-features';

const filterDuplicateIcons = featuresAndUnits =>
  featuresAndUnits.reduce((acc, code) => {
    const featureService = SERVICES_FEATURES[code];

    if (!acc || !featureService || acc.some(obj => obj.Component === featureService.Component)) {
      return acc;
    }

    return [...acc, featureService];
  }, []);

const FeaturesUnitsIcons = ({ building }) => {
  if (!building) {
    return null;
  }

  const featuresAndUnits = filterDuplicateIcons([...building.features, ...building.units]);

  const { t } = useTranslation();

  return (
    <Wrapper>
      {featuresAndUnits.map(({ Component, translation }) => {
        return (
          <Tooltip key={translation} bottom={true}>
            <Component key={translation} />
            {t(translation)}
          </Tooltip>
        );
      })}
    </Wrapper>
  );
};

FeaturesUnitsIcons.propTypes = {
  building: PropTypes.object.isRequired
};

export default FeaturesUnitsIcons;
